import React, { Component } from "react";
import { I2cAvatar } from "@webcomponents/i2cwebcomponents/dist/react";
class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  componentDidCatch(error, info) {
    // Log the error to an error reporting service
    console.error("Error boundary caught an error:", error, info);
    this.setState({ hasError: true });
  }

  render() {
    if (this.state.hasError) {
      return <I2cAvatar size="medium" shape="circle" label="Circle avatar" />;
    }
    return this.props.children;
  }
}

export default ErrorBoundary;
